import { booleanParser, createArrayWithBracesParser, numberArrayParser, numberParser } from '../inboundParsers';
import { chipsBetPerPlayerParser } from './utils/chipsBetPerPlayerInboundUtils';
import { lastActionParser } from './utils/lastActionInboundUtils';
export const SIDE_BET_PHASE_PAYLOAD_DEFINITION = {
    shouldSplitWithBraces: true,
    definitionParts: [
        { name: 'chipsBetPerPlayer', parser: createArrayWithBracesParser(chipsBetPerPlayerParser) },
        { name: 'potAmounts', parser: numberArrayParser },
        { name: 'lastAction', parser: lastActionParser },
        { name: 'durationMs', parser: numberParser },
        { name: 'disableSideBetsInterface', parser: booleanParser }
    ]
};
